import type { Node as PMNode } from '@atlaskit/editor-prosemirror/model';

/** Position immediately after the last matching localId, or `undefined` if none exist. */
export function getRemixWidgetPosition(
	doc: PMNode,
	localIds: readonly string[],
): number | undefined {
	if (localIds.length === 0) {
		return undefined;
	}

	const targetLocalIds = new Set(localIds);
	let position: number | undefined;

	doc.descendants((node, pos) => {
		const id = node.attrs?.localId;
		if (typeof id === 'string' && targetLocalIds.has(id)) {
			position = pos + node.nodeSize;
			return false;
		}
		return true;
	});

	return position;
}
